import { Location } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output
} from '@angular/core'

import { SearchResponseType } from '../../../services/global-search.service'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { FindTrackType } from '../../../types/filter.type'

@Component({
  selector: 'bmcore-search-beatmaker-input',
  templateUrl: './bmcore-search-beatmaker-input.component.html',
  styleUrls: ['./bmcore-search-beatmaker-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreSearchBeatmakerInputComponent implements OnInit {
  @Input() beatmakers: SearchResponseType[] = []
  @Input() isBeatmakerDropdown = false
  @Input() searchBeatmakerTitle: string

  @Output() findTracksByBeatmakerNameEvent = new EventEmitter<SearchResponseType>()
  @Output() changeBeatmakerValueEvent = new EventEmitter<FindTrackType>()
  @Output() showTagDropdownEvent = new EventEmitter<boolean>()
  @Output() showBeatmakerDropdownEvent = new EventEmitter<boolean>()
  @Output() clearSearchBeatmakerTitleEvent = new EventEmitter()

  lg: LgType

  constructor(
    private i18nService: I18nService,
    private eRef: ElementRef,
    private location: Location
  ) {
    this.lg = this.i18nService.getLanguageForPage()
  }

  ngOnInit(): void {}

  // close search dropdown when click outside
  // https://stackoverflow.com/a/40107009
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      if (event.target.nodeName === 'DIV') {
        if (this.isBeatmakerDropdown) {
          this.clearBeatmakerField()
        }
      }
    }
  }

  changeBeatmakerValue(searchData: FindTrackType) {
    this.changeBeatmakerValueEvent.emit({ search: searchData.search, searchType: searchData.searchType })
  }

  findTracksByBeatmakerName(id: number, value: string) {
    this.showBeatmakerDropdownEvent.emit(false)
    this.findTracksByBeatmakerNameEvent.emit({ id, value })
  }

  closeTagDropdown() {
    this.showTagDropdownEvent.emit(false)
  }

  clearBeatmakerField() {
    const locationPath = this.location.path()

    if (locationPath.includes('beatmaker')) {
      this.closeTagDropdown()
      this.changeBeatmakerValue({ search: '', searchType: 'beatmaker' })
    } else {
      this.showBeatmakerDropdownEvent.emit(false)
      this.clearSearchBeatmakerTitleEvent.emit()
    }
  }
}
